const a = {
  addToFolder: () => import("./SVGs/addToFolder.svg.mjs"),
  addedtoFolder: () => import("./SVGs/addedtoFolder.svg.mjs"),
  aiWand: () => import("./SVGs/aiWand.svg.mjs"),
  alarmBell: () => import("./SVGs/alarmBell.svg.mjs"),
  alignBottom: () => import("./SVGs/alignBottom.svg.mjs"),
  alignCenter: () => import("./SVGs/alignCenter.svg.mjs"),
  alignLeft: () => import("./SVGs/alignLeft.svg.mjs"),
  alignMiddle: () => import("./SVGs/alignMiddle.svg.mjs"),
  alignRight: () => import("./SVGs/alignRight.svg.mjs"),
  alignTop: () => import("./SVGs/alignTop.svg.mjs"),
  amex: () => import("./SVGs/amex.svg.mjs"),
  applePay: () => import("./SVGs/applePay.svg.mjs"),
  arrowBack: () => import("./SVGs/arrowBack.svg.mjs"),
  arrowCursorBlue: () => import("./SVGs/arrowCursor_blue.svg.mjs"),
  arrowCursorPink: () => import("./SVGs/arrowCursor_pink.svg.mjs"),
  arrowCursorYellow: () => import("./SVGs/arrowCursor_yellow.svg.mjs"),
  arrowDown: () => import("./SVGs/arrowDown.svg.mjs"),
  arrowRight: () => import("./SVGs/arrowRight.svg.mjs"),
  arrowUp: () => import("./SVGs/arrowUp.svg.mjs"),
  attachment: () => import("./SVGs/attachment.svg.mjs"),
  audioModified: () => import("./SVGs/audioModified.svg.mjs"),
  blankCalendarBlue: () => import("./SVGs/blankCalendar_blue.svg.mjs"),
  blankCalendarPink: () => import("./SVGs/blankCalendar_pink.svg.mjs"),
  blankCalendarYellow: () => import("./SVGs/blankCalendar_yellow.svg.mjs"),
  brain: () => import("./SVGs/brain.svg.mjs"),
  businessStartupBlue: () => import("./SVGs/businessStartup_blue.svg.mjs"),
  businessStartupPink: () => import("./SVGs/businessStartup_pink.svg.mjs"),
  businessStartupYellow: () => import("./SVGs/businessStartup_yellow.svg.mjs"),
  calendar: () => import("./SVGs/calendar.svg.mjs"),
  cameraBlue: () => import("./SVGs/camera_blue.svg.mjs"),
  cameraPink: () => import("./SVGs/camera_pink.svg.mjs"),
  cameraYellow: () => import("./SVGs/camera_yellow.svg.mjs"),
  cameraVideoBlue: () => import("./SVGs/cameraVideo_blue.svg.mjs"),
  cameraVideoPink: () => import("./SVGs/cameraVideo_pink.svg.mjs"),
  cameraVideoYellow: () => import("./SVGs/cameraVideo_yellow.svg.mjs"),
  chatBubbleTypingOvalBlue: () => import("./SVGs/chatBubbleTypingOval_blue.svg.mjs"),
  chatBubbleTypingOvalPink: () => import("./SVGs/chatBubbleTypingOval_pink.svg.mjs"),
  chatBubbleTypingOvalYellow: () => import("./SVGs/chatBubbleTypingOval_yellow.svg.mjs"),
  chatTwoBubblesSquareBlue: () => import("./SVGs/chatTwoBubblesSquare_blue.svg.mjs"),
  chatTwoBubblesSquarePink: () => import("./SVGs/chatTwoBubblesSquare_pink.svg.mjs"),
  chatTwoBubblesSquareYellow: () => import("./SVGs/chatTwoBubblesSquare_yellow.svg.mjs"),
  check: () => import("./SVGs/check.svg.mjs"),
  checkCircle: () => import("./SVGs/checkCircle.svg.mjs"),
  chevronDown: () => import("./SVGs/chevronDown.svg.mjs"),
  chevronLeft: () => import("./SVGs/chevronLeft.svg.mjs"),
  chevronRight: () => import("./SVGs/chevronRight.svg.mjs"),
  chevronUp: () => import("./SVGs/chevronUp.svg.mjs"),
  circleCheck: () => import("./SVGs/circleCheck.svg.mjs"),
  circleClockBlack: () => import("./SVGs/circleClock_black.svg.mjs"),
  circleClockBlue: () => import("./SVGs/circleClock_blue.svg.mjs"),
  circleClockPink: () => import("./SVGs/circleClock_pink.svg.mjs"),
  circleClockYellow: () => import("./SVGs/circleClock_yellow.svg.mjs"),
  close: () => import("./SVGs/close.svg.mjs"),
  cog: () => import("./SVGs/cog.svg.mjs"),
  compass: () => import("./SVGs/compass.svg.mjs"),
  controlsForward: () => import("./SVGs/controlsForward.svg.mjs"),
  controlsPause: () => import("./SVGs/controlsPause.svg.mjs"),
  controlsPlay: () => import("./SVGs/controlsPlay.svg.mjs"),
  controlsRecord: () => import("./SVGs/controlsRecord.svg.mjs"),
  controlsRewind: () => import("./SVGs/controlsRewind.svg.mjs"),
  controlsStop: () => import("./SVGs/controlsStop.svg.mjs"),
  dashboardGaugeBlue: () => import("./SVGs/dashboardGauge_blue.svg.mjs"),
  dashboardGaugePink: () => import("./SVGs/dashboardGauge_pink.svg.mjs"),
  dashboardGaugeYellow: () => import("./SVGs/dashboardGauge_yellow.svg.mjs"),
  dinersClub: () => import("./SVGs/dinersClub.svg.mjs"),
  discover: () => import("./SVGs/discover.svg.mjs"),
  downloadBottom: () => import("./SVGs/downloadBottom.svg.mjs"),
  downloadSquareBlue: () => import("./SVGs/downloadSquare_blue.svg.mjs"),
  downloadSquarePink: () => import("./SVGs/downloadSquare_pink.svg.mjs"),
  downloadSquareYellow: () => import("./SVGs/downloadSquare_yellow.svg.mjs"),
  dropbox: () => import("./SVGs/dropbox.svg.mjs"),
  emptyClipboardBlue: () => import("./SVGs/emptyClipboard_blue.svg.mjs"),
  emptyClipboardPink: () => import("./SVGs/emptyClipboard_pink.svg.mjs"),
  emptyClipboardYellow: () => import("./SVGs/emptyClipboard_yellow.svg.mjs"),
  erlenmeyerFlaskBlue: () => import("./SVGs/erlenmeyerFlask_blue.svg.mjs"),
  erlenmeyerFlaskPink: () => import("./SVGs/erlenmeyerFlask_pink.svg.mjs"),
  erlenmeyerFlaskYellow: () => import("./SVGs/erlenmeyerFlask_yellow.svg.mjs"),
  error: () => import("./SVGs/error.svg.mjs"),
  expandHorizontal: () => import("./SVGs/expandHorizontal.svg.mjs"),
  expandVertical: () => import("./SVGs/expandVertical.svg.mjs"),
  facebook: () => import("./SVGs/facebook.svg.mjs"),
  favorite: () => import("./SVGs/favorite.svg.mjs"),
  favoriteFilled: () => import("./SVGs/favoriteFilled.svg.mjs"),
  fileDouble: () => import("./SVGs/fileDouble.svg.mjs"),
  filter: () => import("./SVGs/filter.svg.mjs"),
  filterImage: () => import("./SVGs/filterImage.svg.mjs"),
  filterMusic: () => import("./SVGs/filterMusic.svg.mjs"),
  filterPlus: () => import("./SVGs/filterPlus.svg.mjs"),
  filterVideo: () => import("./SVGs/filterVideo.svg.mjs"),
  folderStar: () => import("./SVGs/folderStar.svg.mjs"),
  generateImage: () => import("./SVGs/generateImage.svg.mjs"),
  generateVideo: () => import("./SVGs/generateVideo.svg.mjs"),
  gitHub: () => import("./SVGs/gitHub.svg.mjs"),
  googlePay: () => import("./SVGs/googlePay.svg.mjs"),
  graphPieChartBlue: () => import("./SVGs/graphPieChart_blue.svg.mjs"),
  graphPieChartPink: () => import("./SVGs/graphPieChart_pink.svg.mjs"),
  graphPieChartYellow: () => import("./SVGs/graphPieChart_yellow.svg.mjs"),
  gridRulesBlue: () => import("./SVGs/gridRules_blue.svg.mjs"),
  gridRulesPink: () => import("./SVGs/gridRules_pink.svg.mjs"),
  gridRulesYellow: () => import("./SVGs/gridRules_yellow.svg.mjs"),
  happyFaceBlue: () => import("./SVGs/happyFace_blue.svg.mjs"),
  happyFacePink: () => import("./SVGs/happyFace_pink.svg.mjs"),
  happyFaceYellow: () => import("./SVGs/happyFace_yellow.svg.mjs"),
  headphonesCustomer: () => import("./SVGs/headphonesCustomer.svg.mjs"),
  helpChatBlue: () => import("./SVGs/helpChat_blue.svg.mjs"),
  helpChatPink: () => import("./SVGs/helpChat_pink.svg.mjs"),
  helpChatYellow: () => import("./SVGs/helpChat_yellow.svg.mjs"),
  homeBlue: () => import("./SVGs/home_blue.svg.mjs"),
  homePink: () => import("./SVGs/home_pink.svg.mjs"),
  homeYellow: () => import("./SVGs/home_yellow.svg.mjs"),
  hourGlassBlue: () => import("./SVGs/hourGlass_blue.svg.mjs"),
  hourGlassPink: () => import("./SVGs/hourGlass_pink.svg.mjs"),
  hourGlassYellow: () => import("./SVGs/hourGlass_yellow.svg.mjs"),
  house: () => import("./SVGs/house.svg.mjs"),
  image: () => import("./SVGs/image.svg.mjs"),
  imageModified: () => import("./SVGs/imageModified.svg.mjs"),
  informationCircle: () => import("./SVGs/informationCircle.svg.mjs"),
  informationCircleInverted: () => import("./SVGs/informationCircleInverted.svg.mjs"),
  instagram: () => import("./SVGs/instagram.svg.mjs"),
  interfaceAlertAlarmBellBlue: () => import("./SVGs/interfaceAlertAlarmBell_blue.svg.mjs"),
  interfaceAlertAlarmBellPink: () => import("./SVGs/interfaceAlertAlarmBell_pink.svg.mjs"),
  interfaceAlertAlarmBellYellow: () => import("./SVGs/interfaceAlertAlarmBell_yellow.svg.mjs"),
  interfaceAwardTrophyBlue: () => import("./SVGs/interfaceAwardTrophy_blue.svg.mjs"),
  interfaceAwardTrophyPink: () => import("./SVGs/interfaceAwardTrophy_pink.svg.mjs"),
  interfaceAwardTrophyYellow: () => import("./SVGs/interfaceAwardTrophy_yellow.svg.mjs"),
  interfaceCursorArrowBlue: () => import("./SVGs/interfaceCursorArrow_blue.svg.mjs"),
  interfaceCursorArrowPink: () => import("./SVGs/interfaceCursorArrow_pink.svg.mjs"),
  interfaceCursorArrowYellow: () => import("./SVGs/interfaceCursorArrow_yellow.svg.mjs"),
  interfaceFavoriteLikeBlue: () => import("./SVGs/interfaceFavoriteLike_blue.svg.mjs"),
  interfaceFavoriteLikePink: () => import("./SVGs/interfaceFavoriteLike_pink.svg.mjs"),
  interfaceFavoriteLikeYellow: () => import("./SVGs/interfaceFavoriteLike_yellow.svg.mjs"),
  interfaceImageVideoAudioSubtitlesBlue: () => import("./SVGs/interfaceImageVideoAudioSubtitles_blue.svg.mjs"),
  interfaceImageVideoAudioSubtitlesPink: () => import("./SVGs/interfaceImageVideoAudioSubtitles_pink.svg.mjs"),
  interfaceImageVideoAudioSubtitlesYellow: () => import("./SVGs/interfaceImageVideoAudioSubtitles_yellow.svg.mjs"),
  interfaceLightingLightBulbBlue: () => import("./SVGs/interfaceLightingLightBulb_blue.svg.mjs"),
  interfaceLightingLightBulbPink: () => import("./SVGs/interfaceLightingLightBulb_pink.svg.mjs"),
  interfaceLightingLightBulbYellow: () => import("./SVGs/interfaceLightingLightBulb_yellow.svg.mjs"),
  interfaceSearchBlue: () => import("./SVGs/interfaceSearch_blue.svg.mjs"),
  interfaceSearchPink: () => import("./SVGs/interfaceSearch_pink.svg.mjs"),
  interfaceSearchYellow: () => import("./SVGs/interfaceSearch_yellow.svg.mjs"),
  keyboardBlue: () => import("./SVGs/keyboard_blue.svg.mjs"),
  keyboardPink: () => import("./SVGs/keyboard_pink.svg.mjs"),
  keyboardYellow: () => import("./SVGs/keyboard_yellow.svg.mjs"),
  keyboardArrowRight: () => import("./SVGs/keyboardArrowRight.svg.mjs"),
  layersBlue: () => import("./SVGs/layers_blue.svg.mjs"),
  layersPink: () => import("./SVGs/layers_pink.svg.mjs"),
  layersYellow: () => import("./SVGs/layers_yellow.svg.mjs"),
  layoutWindowBlue: () => import("./SVGs/layoutWindow_blue.svg.mjs"),
  layoutWindowPink: () => import("./SVGs/layoutWindow_pink.svg.mjs"),
  layoutWindowYellow: () => import("./SVGs/layoutWindow_yellow.svg.mjs"),
  linkedIn: () => import("./SVGs/linkedIn.svg.mjs"),
  loadingRing: () => import("./SVGs/loadingRing.svg.mjs"),
  lock: () => import("./SVGs/lock.svg.mjs"),
  lockUnlock: () => import("./SVGs/lockUnlock.svg.mjs"),
  loginBlue: () => import("./SVGs/login_blue.svg.mjs"),
  loginPink: () => import("./SVGs/login_pink.svg.mjs"),
  loginYellow: () => import("./SVGs/login_yellow.svg.mjs"),
  logoStoryblocks: () => import("./SVGs/logoStoryblocks.svg.mjs"),
  logoStoryblocksGray: () => import("./SVGs/logoStoryblocksGray.svg.mjs"),
  logoStoryblocksWhite: () => import("./SVGs/logoStoryblocksWhite.svg.mjs"),
  maestro: () => import("./SVGs/maestro.svg.mjs"),
  magicWandBlue: () => import("./SVGs/magicWand_blue.svg.mjs"),
  magicWandPink: () => import("./SVGs/magicWand_pink.svg.mjs"),
  magicWandYellow: () => import("./SVGs/magicWand_yellow.svg.mjs"),
  maker: () => import("./SVGs/maker.svg.mjs"),
  mastercard: () => import("./SVGs/mastercard.svg.mjs"),
  meetingCamera: () => import("./SVGs/meetingCamera.svg.mjs"),
  megaphoneBlue: () => import("./SVGs/megaphone_blue.svg.mjs"),
  megaphonePink: () => import("./SVGs/megaphone_pink.svg.mjs"),
  megaphoneYellow: () => import("./SVGs/megaphone_yellow.svg.mjs"),
  microphone: () => import("./SVGs/microphone.svg.mjs"),
  microphoneOff: () => import("./SVGs/microphoneOff.svg.mjs"),
  moneyCashBillBlue: () => import("./SVGs/moneyCashBill_blue.svg.mjs"),
  moneyCashBillPink: () => import("./SVGs/moneyCashBill_pink.svg.mjs"),
  moneyCashBillYellow: () => import("./SVGs/moneyCashBill_yellow.svg.mjs"),
  moneyWalletBlue: () => import("./SVGs/moneyWallet_blue.svg.mjs"),
  moneyWalletPink: () => import("./SVGs/moneyWallet_pink.svg.mjs"),
  moneyWalletYellow: () => import("./SVGs/moneyWallet_yellow.svg.mjs"),
  musicSound: () => import("./SVGs/musicSound.svg.mjs"),
  navigationMenuHorizontal: () => import("./SVGs/navigationMenuHorizontal.svg.mjs"),
  navigationMenuVertical: () => import("./SVGs/navigationMenuVertical.svg.mjs"),
  newStickyNoteBlue: () => import("./SVGs/newStickyNote_blue.svg.mjs"),
  newStickyNotePink: () => import("./SVGs/newStickyNote_pink.svg.mjs"),
  newStickyNoteYellow: () => import("./SVGs/newStickyNote_yellow.svg.mjs"),
  oneFingerTapBlue: () => import("./SVGs/oneFingerTap_blue.svg.mjs"),
  oneFingerTapPink: () => import("./SVGs/oneFingerTap_pink.svg.mjs"),
  oneFingerTapYellow: () => import("./SVGs/oneFingerTap_yellow.svg.mjs"),
  openBookBlue: () => import("./SVGs/openBook_blue.svg.mjs"),
  openBookPink: () => import("./SVGs/openBook_pink.svg.mjs"),
  openBookYellow: () => import("./SVGs/openBook_yellow.svg.mjs"),
  panelCollapse: () => import("./SVGs/panelCollapse.svg.mjs"),
  panelExpand: () => import("./SVGs/panelExpand.svg.mjs"),
  paragraphLeftAlign: () => import("./SVGs/paragraphLeftAlign.svg.mjs"),
  paragraphsCenterAlign: () => import("./SVGs/paragraphsCenterAlign.svg.mjs"),
  paragraphsRightAlign: () => import("./SVGs/paragraphsRightAlign.svg.mjs"),
  payPal: () => import("./SVGs/payPal.svg.mjs"),
  penBlue: () => import("./SVGs/pen_blue.svg.mjs"),
  penPink: () => import("./SVGs/pen_pink.svg.mjs"),
  penYellow: () => import("./SVGs/pen_yellow.svg.mjs"),
  pencil: () => import("./SVGs/pencil.svg.mjs"),
  picturesFolderMemoriesBlue: () => import("./SVGs/picturesFolderMemories_blue.svg.mjs"),
  picturesFolderMemoriesPink: () => import("./SVGs/picturesFolderMemories_pink.svg.mjs"),
  picturesFolderMemoriesYellow: () => import("./SVGs/picturesFolderMemories_yellow.svg.mjs"),
  pinBlue: () => import("./SVGs/pin_blue.svg.mjs"),
  pinPink: () => import("./SVGs/pin_pink.svg.mjs"),
  pinYellow: () => import("./SVGs/pin_yellow.svg.mjs"),
  pinterest: () => import("./SVGs/pinterest.svg.mjs"),
  playListBlue: () => import("./SVGs/playList_blue.svg.mjs"),
  playListPink: () => import("./SVGs/playList_pink.svg.mjs"),
  playListYellow: () => import("./SVGs/playList_yellow.svg.mjs"),
  playVideo: () => import("./SVGs/playVideo.svg.mjs"),
  plus: () => import("./SVGs/plus.svg.mjs"),
  profileAvatar: () => import("./SVGs/profileAvatar.svg.mjs"),
  questionmark: () => import("./SVGs/questionmark.svg.mjs"),
  refresh: () => import("./SVGs/refresh.svg.mjs"),
  screenTvBlue: () => import("./SVGs/screenTv_blue.svg.mjs"),
  screenTvPink: () => import("./SVGs/screenTv_pink.svg.mjs"),
  screenTvYellow: () => import("./SVGs/screenTv_yellow.svg.mjs"),
  scriptBlue: () => import("./SVGs/script_blue.svg.mjs"),
  scriptPink: () => import("./SVGs/script_pink.svg.mjs"),
  scriptYellow: () => import("./SVGs/script_yellow.svg.mjs"),
  search: () => import("./SVGs/search.svg.mjs"),
  searchSimilar: () => import("./SVGs/searchSimilar.svg.mjs"),
  settingMenu: () => import("./SVGs/settingMenu.svg.mjs"),
  share: () => import("./SVGs/share.svg.mjs"),
  shoppingCartBlue: () => import("./SVGs/shoppingCart_blue.svg.mjs"),
  shoppingCartPink: () => import("./SVGs/shoppingCart_pink.svg.mjs"),
  shoppingCartYellow: () => import("./SVGs/shoppingCart_yellow.svg.mjs"),
  snapchat: () => import("./SVGs/snapchat.svg.mjs"),
  sparkle: () => import("./SVGs/sparkle.svg.mjs"),
  sparkles: () => import("./SVGs/sparkles.svg.mjs"),
  stamp: () => import("./SVGs/stamp.svg.mjs"),
  starFourSided: () => import("./SVGs/starFourSided.svg.mjs"),
  stopwatchBlue: () => import("./SVGs/stopwatch_blue.svg.mjs"),
  stopwatchPink: () => import("./SVGs/stopwatch_pink.svg.mjs"),
  stopwatchYellow: () => import("./SVGs/stopwatch_yellow.svg.mjs"),
  stripe: () => import("./SVGs/stripe.svg.mjs"),
  sunCloudBlue: () => import("./SVGs/sunCloud_blue.svg.mjs"),
  sunCloudPink: () => import("./SVGs/sunCloud_pink.svg.mjs"),
  sunCloudYellow: () => import("./SVGs/sunCloud_yellow.svg.mjs"),
  textBold: () => import("./SVGs/textBold.svg.mjs"),
  textInputArea: () => import("./SVGs/textInputArea.svg.mjs"),
  textItalic: () => import("./SVGs/textItalic.svg.mjs"),
  textStrikeThrough: () => import("./SVGs/textStrikeThrough.svg.mjs"),
  textStyle: () => import("./SVGs/textStyle.svg.mjs"),
  textUnderline: () => import("./SVGs/textUnderline.svg.mjs"),
  thirdEye: () => import("./SVGs/thirdEye.svg.mjs"),
  thumbDown: () => import("./SVGs/thumbDown.svg.mjs"),
  thumbUp: () => import("./SVGs/thumbUp.svg.mjs"),
  trash: () => import("./SVGs/trash.svg.mjs"),
  travelMapEarthBlue: () => import("./SVGs/travelMapEarth_blue.svg.mjs"),
  travelMapEarthPink: () => import("./SVGs/travelMapEarth_pink.svg.mjs"),
  travelMapEarthYellow: () => import("./SVGs/travelMapEarth_yellow.svg.mjs"),
  twitter: () => import("./SVGs/twitter.svg.mjs"),
  uploadBottom: () => import("./SVGs/uploadBottom.svg.mjs"),
  uploadCircleBlue: () => import("./SVGs/uploadCircle_blue.svg.mjs"),
  uploadCirclePink: () => import("./SVGs/uploadCircle_pink.svg.mjs"),
  uploadCircleYellow: () => import("./SVGs/uploadCircle_yellow.svg.mjs"),
  userCircleSingleBlue: () => import("./SVGs/userCircleSingle_blue.svg.mjs"),
  userCircleSinglePink: () => import("./SVGs/userCircleSingle_pink.svg.mjs"),
  userCircleSingleYellow: () => import("./SVGs/userCircleSingle_yellow.svg.mjs"),
  userSingleBlue: () => import("./SVGs/userSingle_blue.svg.mjs"),
  userSinglePink: () => import("./SVGs/userSingle_pink.svg.mjs"),
  userSingleYellow: () => import("./SVGs/userSingle_yellow.svg.mjs"),
  venmo: () => import("./SVGs/venmo.svg.mjs"),
  verticalSliderSquareBlue: () => import("./SVGs/verticalSliderSquare_blue.svg.mjs"),
  verticalSliderSquarePink: () => import("./SVGs/verticalSliderSquare_pink.svg.mjs"),
  verticalSliderSquareYellow: () => import("./SVGs/verticalSliderSquare_yellow.svg.mjs"),
  video: () => import("./SVGs/video.svg.mjs"),
  videoEditPeel: () => import("./SVGs/videoEditPeel.svg.mjs"),
  videoEditSplit: () => import("./SVGs/videoEditSplit.svg.mjs"),
  videoModified: () => import("./SVGs/videoModified.svg.mjs"),
  videoPlayerAlternate: () => import("./SVGs/videoPlayerAlternate.svg.mjs"),
  view: () => import("./SVGs/view.svg.mjs"),
  viewOff: () => import("./SVGs/viewOff.svg.mjs"),
  visa: () => import("./SVGs/visa.svg.mjs"),
  voiceMailBlue: () => import("./SVGs/voiceMail_blue.svg.mjs"),
  voiceMailPink: () => import("./SVGs/voiceMail_pink.svg.mjs"),
  voiceMailYellow: () => import("./SVGs/voiceMail_yellow.svg.mjs"),
  volumeDown: () => import("./SVGs/volumeDown.svg.mjs"),
  volumeLevelHighBlue: () => import("./SVGs/volumeLevelHigh_blue.svg.mjs"),
  volumeLevelHighPink: () => import("./SVGs/volumeLevelHigh_pink.svg.mjs"),
  volumeLevelHighYellow: () => import("./SVGs/volumeLevelHigh_yellow.svg.mjs"),
  volumeMedium: () => import("./SVGs/volumeMedium.svg.mjs"),
  volumeOff: () => import("./SVGs/volumeOff.svg.mjs"),
  volumeUp: () => import("./SVGs/volumeUp.svg.mjs"),
  warningTriangle: () => import("./SVGs/warningTriangle.svg.mjs"),
  waveform: () => import("./SVGs/waveform.svg.mjs"),
  webcamVideoBlue: () => import("./SVGs/webcamVideo_blue.svg.mjs"),
  webcamVideoPink: () => import("./SVGs/webcamVideo_pink.svg.mjs"),
  webcamVideoYellow: () => import("./SVGs/webcamVideo_yellow.svg.mjs"),
  youtube: () => import("./SVGs/youtube.svg.mjs"),
  zap: () => import("./SVGs/zap.svg.mjs")
}, t = /* @__PURE__ */ new Set([
  "arrowCursor",
  "blankCalendar",
  "businessStartup",
  "camera",
  "cameraVideo",
  "chatBubbleTypingOval",
  "chatTwoBubblesSquare",
  "circleClock",
  "dashboardGauge",
  "downloadSquare",
  "emptyClipboard",
  "erlenmeyerFlask",
  "graphPieChart",
  "gridRules",
  "happyFace",
  "helpChat",
  "home",
  "hourGlass",
  "interfaceAlertAlarmBell",
  "interfaceAwardTrophy",
  "interfaceCursorArrow",
  "interfaceFavoriteLike",
  "interfaceImageVideoAudioSubtitles",
  "interfaceLightingLightBulb",
  "interfaceSearch",
  "keyboard",
  "layers",
  "layoutWindow",
  "login",
  "magicWand",
  "megaphone",
  "moneyCashBill",
  "moneyWallet",
  "newStickyNote",
  "oneFingerTap",
  "openBook",
  "pen",
  "picturesFolderMemories",
  "pin",
  "playList",
  "screenTv",
  "script",
  "shoppingCart",
  "stopwatch",
  "sunCloud",
  "travelMapEarth",
  "uploadCircle",
  "userCircleSingle",
  "userSingle",
  "verticalSliderSquare",
  "voiceMail",
  "volumeLevelHigh",
  "webcamVideo"
]), p = {
  arrowCursor: ["blue", "pink", "yellow"],
  blankCalendar: ["blue", "pink", "yellow"],
  businessStartup: ["blue", "pink", "yellow"],
  camera: ["blue", "pink", "yellow"],
  cameraVideo: ["blue", "pink", "yellow"],
  chatBubbleTypingOval: ["blue", "pink", "yellow"],
  chatTwoBubblesSquare: ["blue", "pink", "yellow"],
  circleClock: ["black", "blue", "pink", "yellow"],
  dashboardGauge: ["blue", "pink", "yellow"],
  downloadSquare: ["blue", "pink", "yellow"],
  emptyClipboard: ["blue", "pink", "yellow"],
  erlenmeyerFlask: ["blue", "pink", "yellow"],
  graphPieChart: ["blue", "pink", "yellow"],
  gridRules: ["blue", "pink", "yellow"],
  happyFace: ["blue", "pink", "yellow"],
  helpChat: ["blue", "pink", "yellow"],
  home: ["blue", "pink", "yellow"],
  hourGlass: ["blue", "pink", "yellow"],
  interfaceAlertAlarmBell: ["blue", "pink", "yellow"],
  interfaceAwardTrophy: ["blue", "pink", "yellow"],
  interfaceCursorArrow: ["blue", "pink", "yellow"],
  interfaceFavoriteLike: ["blue", "pink", "yellow"],
  interfaceImageVideoAudioSubtitles: ["blue", "pink", "yellow"],
  interfaceLightingLightBulb: ["blue", "pink", "yellow"],
  interfaceSearch: ["blue", "pink", "yellow"],
  keyboard: ["blue", "pink", "yellow"],
  layers: ["blue", "pink", "yellow"],
  layoutWindow: ["blue", "pink", "yellow"],
  login: ["blue", "pink", "yellow"],
  magicWand: ["blue", "pink", "yellow"],
  megaphone: ["blue", "pink", "yellow"],
  moneyCashBill: ["blue", "pink", "yellow"],
  moneyWallet: ["blue", "pink", "yellow"],
  newStickyNote: ["blue", "pink", "yellow"],
  oneFingerTap: ["blue", "pink", "yellow"],
  openBook: ["blue", "pink", "yellow"],
  pen: ["blue", "pink", "yellow"],
  picturesFolderMemories: ["blue", "pink", "yellow"],
  pin: ["blue", "pink", "yellow"],
  playList: ["blue", "pink", "yellow"],
  screenTv: ["blue", "pink", "yellow"],
  script: ["blue", "pink", "yellow"],
  shoppingCart: ["blue", "pink", "yellow"],
  stopwatch: ["blue", "pink", "yellow"],
  sunCloud: ["blue", "pink", "yellow"],
  travelMapEarth: ["blue", "pink", "yellow"],
  uploadCircle: ["blue", "pink", "yellow"],
  userCircleSingle: ["blue", "pink", "yellow"],
  userSingle: ["blue", "pink", "yellow"],
  verticalSliderSquare: ["blue", "pink", "yellow"],
  voiceMail: ["blue", "pink", "yellow"],
  volumeLevelHigh: ["blue", "pink", "yellow"],
  webcamVideo: ["blue", "pink", "yellow"]
};
function m(e, i) {
  let r = e;
  if (t.has(e)) {
    const o = p[e] || [], l = i || o[0];
    if (i && !o.includes(i))
      return console.error('Invalid variant "' + i + '" for icon "' + e + '". Available variants: ' + o.join(", ")), null;
    r = e + l.charAt(0).toUpperCase() + l.slice(1);
  } else i && console.warn('Icon "' + e + '" does not support variants. Ignoring variant "' + i + '".');
  return a[r] || null;
}
function n(e) {
  return t.has(e);
}
function u(e) {
  const i = p[e];
  return i ? i[0] : void 0;
}
export {
  u as getDefaultVariant,
  m as getIconImport,
  n as hasVariants
};
